var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegalPageLayout',{attrs:{"title":_vm.$t('general conditions').toString(),"content":_vm.generalConditions}})}
var staticRenderFns = []

export { render, staticRenderFns }